export const transformDetailedCypressLogs = (
  rawData,
  logs = [],
  currentCount = 0
) => {
  if (typeof rawData === "object") {
    const keys = Object.keys(rawData);
    keys.map(key => {
      currentCount !== 0 ? logs.push(`${currentCount}.${key}`) : logs.push(key);
      currentCount++;

      if (typeof rawData[key] === "object" && Array.isArray(rawData[key])) {
        logs.push(...rawData[key]);
      } else {
        transformDetailedCypressLogs(rawData[key], logs, currentCount);
      }
    });

    return logs;
  }
  return null;
};
